import moment from "moment";

export function rawTimeToLocal(rawTime) {
    const today = moment().format('YYYY-MM-DD');
    return moment.utc(`${today}T${rawTime}`).local().format('HH:mm:ss');
}

export function rawLocalTimeToUTC(rawLocalTime) {
    const today = moment().format('YYYY-MM-DD');
    return moment(`${today}T${rawLocalTime}`).utc().format('HH:mm:ss[Z]');
}

export function calculate_end_time(start_time, end_time) {
    let start_time_seconds = hours_to_seconds(start_time.split(':')[0]) + minutes_to_seconds(start_time.split(':')[1])
    let end_time_seconds = hours_to_seconds(end_time.split(':')[0]) + minutes_to_seconds(end_time.split(':')[1])

    let new_end_time = (end_time_seconds + start_time_seconds)
    if (new_end_time > 86400) {
        new_end_time = new_end_time - 86400
    }
    return seconds_to_time(new_end_time)
}

function hours_to_seconds(hours) {
    return hours * 60 * 60
}

function minutes_to_seconds(minutes) {
    return minutes * 60
}

function seconds_to_time(seconds) {
    let hours = Math.floor(seconds / 3600);
    let minutes = Math.floor((seconds - (hours * 3600)) / 60);

    if (hours.toString().length < 2) {
        hours = '0' + hours
    }
    if (minutes.toString().length < 2) {
        minutes = '0' + minutes
    }
    return hours + ':' + minutes
}
